var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXAuthor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\uB808\\uC774\\uC5B4_1",
    "data-name": "\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 1227",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M714.2,519.3L1160.9,0h-105.9l-387.9,450.9L357.3,0H0l468.5,681.8L0,1226.4h105.9l409.6-476.2,327.2,476.2h357.3l-485.9-707.1h0ZM569.2,687.8l-47.5-67.9L144,79.7h162.6l304.8,436,47.5,67.9,396.2,566.7h-162.6l-323.3-462.4h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXAuthor);
export default __webpack_public_path__ + "static/media/XAuthor.93f93fa342469d5954880e887bf93e1a.svg";
export { ForwardRef as ReactComponent };